module.exports = __webpack_public_path__ + "img/puzzel.eedd7252.svg";